import { useState } from "react";
import { loginUser } from "../../../services/auth/auth";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../utils/AuthContext";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { addToWishlist } from "../../../services/wishlist";
import { addItemToCart } from "../../../services/cart";

function useLogin() {
  const [isLogging, setIsLogging] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useHistory();
  const { setIsLoggedIn, setUser } = useAuth();

  const syncGuestData = async (userData) => {
    try {
      // Get guest cart and wishlist from localStorage
      const guestCart = JSON.parse(localStorage.getItem("cartGuest") || "[]");
      const guestWishlist = JSON.parse(
        localStorage.getItem("guestWishlist") || "[]"
      );

      // Sync wishlist items
      const wishlistPromises = guestWishlist.map((item) => {
        addToWishlist({
          productId: item.productId,
          priceAtAdded: item.priceAtAdded,
        }).catch((error) => {
          console.error("Error syncing wishlist item:", error);
          return null;
        });
      });
      await Promise.all(wishlistPromises);

      // Sync cart items
      const cartPromises = guestCart.map((item) =>
        addItemToCart(item.productId, item.quantity).catch((error) => {
          console.error("Error syncing cart item:", error);
          return null;
        })
      );
      await Promise.all(cartPromises);

      // Clear guest data from localStorage
      localStorage.removeItem("cartGuest");
      localStorage.removeItem("guestWishlist");

      toast.success("Your cart and wishlist have been synchronized");
    } catch (error) {
      console.error("Error syncing guest data:", error);
      toast.error("Failed to sync some items");
    }
  };

  const loginUserFn = async ({ phone, password }) => {
    setIsLogging(true);
    setError(null);
    try {
      const data = await loginUser(phone, password);
      setIsLoggedIn(true);
      setUser(data?.user);
      Cookies.set("auth_token", data?.token, {
        expires: 7,
        secure: true,
        sameSite: "Strict",
      });
      localStorage.setItem("userData", JSON.stringify(data?.user));

      // Sync guest data after successful login
      await syncGuestData(data?.user);

      if (data.user && data?.user?.role === 1) {
        navigate.push("/admin/dashboard");
      }
      if (data.user && data.user.role !== 1) {
        navigate.push("/");
      }
      toast.success("Successfully logged in");
    } catch (err) {
      toast.error(err?.response?.data?.error || "some error occured");
    } finally {
      setIsLogging(false);
    }
  };

  return {
    loginUserFn,
    isLogging,
    isErrorLogging: error,
  };
}

export default useLogin;
